import { render, staticRenderFns } from "./NewSwiper.vue?vue&type=template&id=323e28ac&scoped=true"
import script from "./NewSwiper.vue?vue&type=script&lang=js"
export * from "./NewSwiper.vue?vue&type=script&lang=js"
import style0 from "./NewSwiper.vue?vue&type=style&index=0&id=323e28ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e28ac",
  null
  
)

export default component.exports